/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Component } from '@angular/core';
import { DialogInput } from '@gh/core-ui';

export interface ImageViewerDialogConfig {
  title: string;
  url: any;
}

@Component({
  standalone: false,
  selector: 'gh-image-viewer',
  templateUrl: 'image-viewer-dialog.component.html',
  styleUrls: ['image-viewer-dialog.component.scss'],
})
export class ImageViewerDialogComponent implements DialogInput<ImageViewerDialogConfig> {
  input: ImageViewerDialogConfig;

  get title(): string {
    return this.input.title;
  }

  get url(): any {
    return this.input.url;
  }
}
